/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyReturnBillItem from './pharmacy-return-bill-item';
import PharmacyReturnBillItemDetail from './pharmacy-return-bill-item-detail';
import PharmacyReturnBillItemUpdate from './pharmacy-return-bill-item-update';
import PharmacyReturnBillItemDeleteDialog from './pharmacy-return-bill-item-delete-dialog';

const PharmacyReturnBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyReturnBillItem />} />
    <Route path="new" element={<PharmacyReturnBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyReturnBillItemDetail />} />
      <Route path="edit" element={<PharmacyReturnBillItemUpdate />} />
      <Route path="delete" element={<PharmacyReturnBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyReturnBillItemRoutes;
